
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import { IRichMenu } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:defaultRichMenu', 'update:closeModal'],
})
export default class DefaultRichMenuModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  richMenus!: IRichMenu[]

  selectedMenu: IRichMenu = {}
  search = ''

  get richMenusFilter() {
    if (this.search) {
      return this.richMenus.filter((item) => item.name?.toLowerCase().includes(this.search.toLowerCase()))
    }
    return this.richMenus
  }

  onSelectMenu(menu: IRichMenu) {
    this.selectedMenu = menu
  }

  onSubmit() {
    this.$emit('update:defaultRichMenu', this.selectedMenu)
  }
}
